import { Component, OnInit, ViewChild, ViewContainerRef, Input} from '@angular/core';
import { ModuleService } from '../services/module.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { SharedService } from '../services/shared.service';
import { DataChashingService } from '../services/dataChashing.service';

@Component({
  selector: 'app-compiler',
  templateUrl: './compiler.component.html',
  styleUrls: ['./compiler.component.css']
})
export class CompilerComponent implements OnInit {

  @ViewChild('content', { read: ViewContainerRef,static:true }) content: ViewContainerRef;
  @Input() componetName: string;
  @Input() componetToken: string;
  @Input() setting: any;

  constructor(private moduleService: ModuleService, private sharedService: SharedService,
    private dataChashingService: DataChashingService) { 
     }

  ngOnInit() {

    var x = this.moduleService.ComponentFactory[this.componetName]
    if (this.moduleService.ComponentFactory[this.componetName]) {
      //create setting component
      const component: any = this.content.createComponent(x, 0);
      if (this.setting && this.setting[this.moduleService.site.culture]) {
        component.instance.settings = this.setting[this.moduleService.site.culture]
      } else {
        component.instance.settings = this.setting ? this.setting : {};
      }
      component.instance.settings.js = component.instance.settings.js || component.instance.settings.JS
      component.instance.settings.css = component.instance.settings.css || component.instance.settings.CSS

      component.instance.data = {
        moduleService: this.moduleService,
        SharedService: this.sharedService,
        dataChashingService: this.dataChashingService,

        dayGridPlugin: dayGridPlugin,
        interactionPlugin: interactionPlugin
      };
      this.loadComponentCss(this.componetName + this.componetToken, component.instance.settings)
      this.loadJs(this.componetName + this.componetToken, component.instance.settings)
    } else {
      console.log('No component Found => ' + this.componetName)
    }

  }



  loadJs(key, settings) {
    if (settings.js) {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      //script.type = 'text/javasctipt';
      script.id = key;
      script.appendChild(document.createTextNode(settings.js));
      head.appendChild(script);
    }
  }

  loadComponentCss(key, settings) {
    if (settings.css) {
      const head = document.getElementsByTagName('head')[0];
      const style = document.createElement('style');
      style.type = 'text/css';
      style.id = key;
      style.appendChild(document.createTextNode(settings.css));
      head.appendChild(style);
    }
  }

}
